import Navbar from "./Navbar";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";
import OnlineRadio from "./OnlineRadio";
import ChatRoom from "./ChatRoom";
import Register from "./Register";
import Login from "./Login";
import {
  useCallback,
  useContext,
  useMemo,
  useReducer,
  useRef,
  useState,
} from "react";
import audiomsgpic from "./otherImg/audiomsgsimg.jpg";
import videomsgpic from "./otherImg/videomsgsimg.jpg";
import dblogpic from "./otherImg/newedified.png";
import bquiz from "./otherImg/biblequizimg.jpg";
import chatroomicon from "./otherImg/chatroomimg.jpg";
import AudioBooks from "./AudioBooks";
import UserDetails from "./UserDetails";
import AboutPage from "./AboutPage";
import DailyDevotion from "./DailyDevotion";
import ReleaseNote from "./ReleaseNote";
import appIcon from "./otherImg/hbrlitenewicon.png";
import Donation from "./components/Donation";
import AssignmentPage from "./AssignmentPage";
import EnglishBksHome from "./EnglishBooks/EnlishBksHome";
import EnglishBksRead from "./EnglishBooks/EndlishBksRead";
import FilipinoBksHome from "./FilipinoBooks/FilipinoBksHome";
import FilipinoBksRead from "./FilipinoBooks/FilipinoBksRead";
import FrenchBksHome from "./FrenchBooks/FrenchBksHome";
import FrenchBksRead from "./FrenchBooks/FrenchBksRead";
import GermanBksHome from "./GermanBooks/GermanBksHome";
import GermanBksRead from "./GermanBooks/GermanBksRead";
import HindiBksHome from "./HindiBooks/HindiBksHome";
import HindiBksRead from "./HindiBooks/HindiBksRead";
import SpanishBksHome from "./SpanishBooks/SpanishBksHome";
import SpanishBksRead from "./SpanishBooks/SpanishBksRead";
import AssignmentRecord from "./AssignmentRecord";
import ViewAllRecords from "./ViewAllRecords";
import AudioMessages from "./AudioMessages";
import PlayAudioMessage from "./PlayAudioMessage";
import { useEffect } from "react";
import VideoList from "./VideoList";
import VideoPlayer from "./VideoPlayer";
import VideoPlayerdual from "./VideoPlayerdual";
import Feedback from "./Feedback";
import DivineBlogs from "./DivineBlogs";
import BlogPost from "./newComponents/BlogPost";
import UpdateProfile from "./newComponents/UpdateProfile";
import BloggerPage from "./newComponents/BloggerPage";
import SavedBookReadPage from "./newComponents/SavedBookRead";
import PlayAudioBook from "./newComponents/PlayAudioBook";
import Biblequizpage from "./newComponents/Biblequizpage";
import Deleteaccount from "./newComponents/Deleteaccount";
import UserAccout from "./UserAccount";
import ReadDailyDevotion from "./DailyDevotionRead";
import Notfoundpage from "./newComponents/Notfoundpage";
import ViewLiveStream from "./newComponents/ViewLiveStream";
import CreateUserandToken from "./LiveTokenGenerate";
import CustomLiveWebview from "./newComponents/CustomLiveWebView";
import ViewAsHls from "./newComponents/ViewHlsstream";
import PostLiveVideos from "./newComponents/PostLiveVideos";
import ProducerDashboard from "./newComponents2/ProducerDashboard";
import TvPage from "./newComponents2/TvPage";
import { AuthContext } from "./AuthContext";
import {
  HbrCancel,
  HbrDropdownIcon,
  HbrDropUpIcon,
  HbrgroupIcon,
  HbrLiveCam,
  HbrMenuIcon,
  HbrNotificationIcon,
  HbrTvIcon,
} from "./newComponents/Mycustomsvgicons";
import {
  collection,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import db from "./firebase";
import { ConstVariables } from "./newComponents2/ConstantVariables";
import { actionConsts, reducer } from "./newComponents/StateManager";
import { CircularProgress } from "@mui/material";
import NotificationContent from "./newComponents2/NotificationContent";
import ReviewContent from "./newComponents2/ReviewContent";
import ShortVideoPlayer from "./newComponents2/ShortPlayer";
import BlogVideoPlayer from "./newComponents2/BlogVideoPlayer";
import UseLayout from "./newComponents/useLayout";
import { sanitizeText } from "./newComponents/GeneralClasses";
import ChildSafetyPolicy from "./newComponents2/ChildSafetyPolicy";
import UploadMessages from "./newComponents2/UploadMessages";
import MyUploadedMessages from "./newComponents2/MyUploadedMessages";

function App() {
  const [open, setOpen] = useState(false);
  const [dropdowmmenu, setdropdownmenu] = useState(false);
  const [isFocusOnAccountMenu, setIsFocusOnAccountM] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [state, dispatch] = useReducer(reducer, {
    progressIndicator: false,
    scrollDirection: "",
    bookReviewData: null,
    showReviewSheet: false,
  });
  const [recentNotifications, setRecentNotification] = useState([]);
  const [notificationID, setNotificationID] = useState(
    localStorage.getItem("notificationID")
  );
  const [LoginPage, setShowLoginPage] = useState({
    processing: true,
    show: false,
  });
  const [uploadMessage, setUploadMessage] = useState(false);
  const [showMyUploads, setShowMyUploads] = useState(false);
  const [showAdminOptions, setShowAdminOptions] = useState(false);
  const [isCursorOnAdminOptions, setIsCursorOnAdminOptions] = useState(false);
  const { user_email } = useContext(AuthContext);
  const { userName } = useContext(AuthContext);
  const { userStatus } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const notificationViewRef = useRef(null);
  const sideBarRef = useRef(null);
  const lastScrollY = useRef(window.scrollY);
  const { width } = UseLayout();

  // useEffect(()=>{
  //    async function getUserStatus() {
  //          const userStatusRef = await get(ref(realTimeDB, `${process.env.REACT_APP_USERSREF}/${sanitizeText(user_email)}/status`));
  //         if (userStatusRef.exists()) {
  //           const adminStatusCode = userStatusRef.val();
  //           if (adminStatusCode === process.env.REACT_ADMIN_STATUS) {
  //             setIsAdmin(true);
  //             console.log(true)
  //           }else{
  //             console.log(false);
  //           }
  //           console.log(adminStatusCode);
  //         }
  //       };
  //       getUserStatus();
  // },[user_email]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current) {
        dispatch({ type: actionConsts.SCROLL_DIRECTION, payload: "down" });
      } else if (currentScrollY < lastScrollY.current) {
        dispatch({ type: actionConsts.SCROLL_DIRECTION, payload: "up" });
      }
      lastScrollY.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  }, [location]);

  useEffect(() => {
    const persistentLogin = localStorage.getItem("persistLogin");
    if (persistentLogin && persistentLogin === "true") {
      setShowLoginPage({ show: false, processing: false });
    } else {
      setShowLoginPage({ show: true, processing: false });
    }
    const bloggerid = localStorage.getItem("bloggerid");
    const legacyUserId = localStorage.getItem("userCode");
    if (legacyUserId && bloggerid) {
      localStorage.removeItem("bloggerid");
      localStorage.removeItem("userCode");
    }
  }, []);

  const handleSignInSuccess = (res) => {
    if (res === true) {
      setShowLoginPage(false);
    }
  };
  const handleOnMouseLeave = () => {
    setTimeout(() => {
      if (dropdowmmenu && isFocusOnAccountMenu) {
        setTimeout(() => {
          setdropdownmenu(false);
          setIsFocusOnAccountM(false);
        }, 50000);
      } else {
        setdropdownmenu(false);
      }
    }, 2000);
  };
  const handleOnMouseLeaveAdminTab = () => {
    setTimeout(() => {
      if (showAdminOptions && isCursorOnAdminOptions) {
        setTimeout(() => {
          setShowAdminOptions(false);
          setIsCursorOnAdminOptions(false);
        }, 50000);
      } else {
        setShowAdminOptions(false);
      }
    }, 2000);
  };

  useEffect(() => {
    if (showNotification) {
      const dismissNotificationView = (e) => {
        if (notificationViewRef) {
          if (!notificationViewRef.current.contains(e.target)) {
            setShowNotification(false);
          }
        }
      };

      document.addEventListener("mousedown", dismissNotificationView);
      return () =>
        document.removeEventListener("mousedown", dismissNotificationView);
    }
  }, [showNotification]);

  useEffect(() => {
    const collectionRef = collection(db, ConstVariables.NOTIFICATION_TEST_PATH);

    if (notificationID) {
      const q = query(
        collectionRef,
        orderBy("docID", "asc"),
        where("docID", ">", notificationID),
        limit(70)
      );
      try {
        // getDocs(q).then((snapshot)=>{
        //   const newNotifications = [];
        //   snapshot.forEach((doc)=>{
        //     newNotifications.push(doc.data());
        //   });
        //   setRecentNotification(newNotifications);
        // });
        const unsub = onSnapshot(q, (snapshot) => {
          const newNotifications = [];
          snapshot.forEach((doc) => {
            newNotifications.push(doc.data());
          });
          setRecentNotification(newNotifications);
        });
        return unsub;
      } catch {}
    } else {
      try {
        const q = query(collectionRef, orderBy("timestamp", "desc"), limit(11));
        getDocs(q).then((snapshot) => {
          const newNotifications = [];
          snapshot.forEach((doc) => {
            newNotifications.push(doc.data());
          });
          setRecentNotification(newNotifications);
        });
      } catch {}
    }
  }, [notificationID]);

  const getNotifications = () => {
    setShowNotification(true);
    dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: true });
    const collectionRef = collection(db, ConstVariables.NOTIFICATION_TEST_PATH);
    const q = query(collectionRef, orderBy("timestamp", "desc"), limit(70));
    getDocs(q).then((snapshot) => {
      const newNotifications = [];
      snapshot.forEach((doc) => {
        newNotifications.push(doc.data());
      });

      if (newNotifications.length > 0) {
        setNotifications(newNotifications);
        const lastDocid = snapshot.docs[0].id;
        setNotificationID(lastDocid);
        localStorage.setItem("notificationID", lastDocid);
        dispatch({ type: actionConsts.PROGRESSINDICATOR, payload: false });
        setRecentNotification([]);
      }
    });
  };
  const memoizedNotifications = useMemo(() => notifications, [notifications]);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const handleOnBookReviewDataReceived = useCallback((data) => {
    if (data) {
      dispatch({ type: actionConsts.SHOW_REVIEW_SHEET, payload: true });
      dispatch({ type: actionConsts.BOOK_REVIEW_DATA, payload: data });
      console.log(data);
    }
  }, []);

  useEffect(() => {
    const closeSideBar = (e) => {
      if (sideBarRef.current) {
        if (!sideBarRef.current.contains(e.target)) {
          setOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", closeSideBar);
    return () => document.removeEventListener("mousedown", closeSideBar);
  }, []);

  const handleUploadMessage = () => {
    setUploadMessage(true);
    setShowAdminOptions(false);
    setIsCursorOnAdminOptions(false);
  };

  const handleShowMyUploads = () => {
    setShowMyUploads(true);
    setShowAdminOptions(false);
    setIsCursorOnAdminOptions(false);
  };

  return !LoginPage.processing ? (
    <div className="App">
      <div className="content">
        {!LoginPage.show && showHeader && (
          <header className="header">
            <div className="headermenuphone" style={{ cursor: "pointer" }}>
              <HbrMenuIcon
                width={"2em"}
                height={"2em"}
                fillColour={"white"}
                handleClick={() => setOpen((prev) => !prev)}
              />
            </div>

            <h3 style={{ color: "teal" }}>
              hbr<span style={{ color: "#eb268f" }}>Web</span>
            </h3>

            {width >= 1110 && (
              <nav className="top-nav flex-row2" style={{ gap: "1em" }}>
                <button
                  onClick={() =>
                    navigate("/aboutPage", {
                      state: { from: location.pathname },
                    })
                  }
                >
                  About
                </button>

                <div
                  onMouseEnter={() => setdropdownmenu(true)}
                  onMouseLeave={handleOnMouseLeave}
                  style={{ position: "relative" }}
                  className="flex-row2"
                >
                  <button>Account</button>

                  {dropdowmmenu ? (
                    <HbrDropUpIcon
                      width={"2em"}
                      height={"2em"}
                      fillColour={"white"}
                    />
                  ) : (
                    <HbrDropdownIcon
                      width={"2em"}
                      height={"2em"}
                      fillColour={"white"}
                    />
                  )}

                  {dropdowmmenu && (
                    <div
                      className="headerdropmenu flex-column1"
                      onMouseEnter={() => setIsFocusOnAccountM(true)}
                      onMouseLeave={() => {
                        setdropdownmenu(false);
                        setIsFocusOnAccountM(false);
                      }}
                    >
                      <button
                        onClick={() =>
                          navigate("/account/update", {
                            state: { from: location.pathname },
                          })
                        }
                      >
                        Account settings
                      </button>
                      <button
                        onClick={() =>
                          navigate(
                            `/profilepage?hbruserref=${sanitizeText(
                              user_email
                            )}&socialhandle=${userName}`,
                            { state: { from: location.pathname } }
                          )
                        }
                      >
                        View profile
                      </button>
                      <button
                        onClick={() =>
                          navigate("/account/delete", {
                            state: { from: location.pathname },
                          })
                        }
                      >
                        Delete Account
                      </button>
                    </div>
                  )}
                </div>
                <button
                  onClick={() =>
                    navigate("/release?type=web", {
                      state: { from: location.pathname },
                    })
                  }
                >
                  Release Note
                </button>
                <button
                  onClick={() =>
                    navigate("/contact", { state: { from: location.pathname } })
                  }
                >
                  Need Help?
                </button>
                <button
                  onClick={() =>
                    navigate("/donation", {
                      state: { from: location.pathname },
                    })
                  }
                >
                  Support Us
                </button>

                {userStatus === process.env.REACT_APP_ADMIN_STATUS && (
                  <div
                    onMouseEnter={() => setShowAdminOptions(true)}
                    onMouseLeave={handleOnMouseLeaveAdminTab}
                    style={{ position: "relative" }}
                    className="flex-row2"
                  >
                    <button>Admin</button>

                    {showAdminOptions && (
                      <div
                        className="headerdropmenu flex-column1"
                        onMouseEnter={() => setIsCursorOnAdminOptions(true)}
                        onMouseLeave={() => {
                          setShowAdminOptions(false);
                          setIsCursorOnAdminOptions(false);
                        }}
                      >
                        <button onClick={handleUploadMessage}>
                          Upload Messages
                        </button>

                        <button onClick={handleShowMyUploads}>
                          My Uploads
                        </button>

                        <button
                          onClick={() =>
                            navigate("/producer-dashboard", {
                              state: { from: location.pathname },
                            })
                          }
                        >
                          Producer Dashboard
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </nav>
            )}

            <div
              className="notifyLayout flex-column1"
              style={{ position: "relative", padding: "5px" }}
            >
              <div
                onClick={() => getNotifications()}
                style={{ cursor: "pointer" }}
              >
                <HbrNotificationIcon
                  width={"2.5em"}
                  height={"2.5em"}
                  fillColour={"white"}
                />
                {recentNotifications && recentNotifications.length >= 1 && (
                  <div
                    style={{
                      borderRadius: "50%",
                      position: "absolute",
                      bottom: "50%",
                      right: "0px",
                      backgroundColor: "red",
                      padding: "5px",
                    }}
                  >
                    <h5 style={{ color: "white" }}>
                      {`${
                        recentNotifications.length > 10
                          ? "10+"
                          : recentNotifications.length > 20
                          ? "20+"
                          : recentNotifications.length > 30
                          ? "30+"
                          : recentNotifications.length > 40
                          ? "40+"
                          : recentNotifications.length > 50
                          ? "50+"
                          : recentNotifications.length > 60
                          ? "60+"
                          : recentNotifications.length
                      }`}
                    </h5>
                  </div>
                )}
              </div>

              <div
                className={`notificationview ${
                  width <= 1110 ? "mobile" : "desktop"
                } flex-column1 ${showNotification ? "show" : "hide"}`}
                ref={notificationViewRef}
              >
                {state.progressIndicator && <CircularProgress />}
                <h3>Notifications</h3>
                <div className="notificationitemlist flex-column1">
                  {memoizedNotifications &&
                    memoizedNotifications.map((data, index) => (
                      <NotificationContent
                        key={index}
                        docID={data.docID}
                        title={data.title}
                        body={data.body}
                        imageUrl={data.imageUrl}
                        postID={data.postID}
                        otherID={data.otherID}
                        user_email={data.user_email}
                        timestamp={data.timestamp}
                        closeNotification={handleCloseNotification}
                        getBookReveiewData={handleOnBookReviewDataReceived}
                      />
                    ))}
                </div>
              </div>
            </div>

            <div className="app-logo">
              <img src={appIcon} alt="" />
            </div>
          </header>
        )}

        {uploadMessage && (
          <UploadMessages handleCancel={() => setUploadMessage(false)} />
        )}
        {showMyUploads && (
          <MyUploadedMessages handleCancel={() => setShowMyUploads(false)} />
        )}

        {!LoginPage.show && showHeader && (
          <section
            className={`navbartopmenus flex-spacebetween ${
              state.scrollDirection === "down" ? "hide" : "show"
            }`}
            style={{
              width: "100%",
              overflowx: "auto",
              marginBottom: "2em",
              zIndex: "2",
              position: "sticky",
              top: "2em",
            }}
          >
            <div className="navcontainer-social flex-column2">
              <h2>Social</h2>
              <div className="flex-row2" style={{ gap: "10px" }}>
                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/chatRoom")}
                >
                  <h4>Chat Room</h4>
                  <img src={chatroomicon} alt="Chat Room Logo" />
                </div>

                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/divineblogs")}
                >
                  <h4>Divine Blogs</h4>
                  <img src={dblogpic} alt="" />
                </div>
              </div>
            </div>

            <div className="navcontainer-connect flex-column2">
              <h2>Connect</h2>
              <div className="flex-row2" style={{ gap: "10px" }}>
                <div className="navcontsocialchilddiv flex-row2">
                  <h3>Live</h3>
                  <div id="hbrlivecam">
                    <HbrLiveCam
                      width="1.7em"
                      height="1.7em"
                      fillColour="#ff0000"
                    />
                  </div>
                </div>
                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/holinesstv")}
                >
                  <h3>hbr Tv</h3>
                  <div id="hbrlivecam">
                    <HbrTvIcon
                      width="1.7em"
                      height="1.7em"
                      fillColour="#eb268f"
                    />
                  </div>
                </div>

                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/horemow_audio_messages")}
                >
                  <h3>Audio Messages</h3>
                  <img src={audiomsgpic} alt="" />
                </div>

                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/horemow_video_messages")}
                >
                  <h3>Video Messages</h3>
                  <img src={videomsgpic} alt="video messages" />
                </div>
              </div>
            </div>

            <div className="navcontainer-quiz flex-column2">
              <h2>Bible Quiz</h2>
              <div className="flex-row2" style={{ gap: "10px" }}>
                <div
                  className="navcontsocialchilddiv flex-row2"
                  onClick={() => navigate("/hbrbiblequiz")}
                >
                  <h3>Bible Quiz</h3>
                  <img src={bquiz} alt="" />
                </div>

                <div className="navcontsocialchilddiv flex-row2">
                  <h3>Top Contestants</h3>
                  <HbrgroupIcon width="2em" height="2em" fillColour="#035A7D" />
                </div>
              </div>
            </div>
          </section>
        )}

        <div className="navigations">
          <Routes>
            <Route path="/">
              <Route
                index
                element={
                  !LoginPage.show ? (
                    <Navbar />
                  ) : (
                    <div
                      className="flex-column2"
                      style={{
                        backgroundColor: "#252a41",
                        width: "100vw",
                        height: "100vh",
                        gap: "20px",
                        zIndex: "3",
                      }}
                    >
                      <h3 style={{ color: "white" }}>
                        Create an HBR account to use horemow book reader app.{" "}
                      </h3>

                      <pre
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          whiteSpace: "pre-wrap",
                          padding: "10px",
                        }}
                      >
                        {`Welcome to the hbrlite book reading and social platform!!! To start using the app Click on the link below to either Login to your account or Create one.`}
                      </pre>

                      <Link
                        to={`/account/create`}
                        style={{
                          color: "black",
                          borderRadius: "10px",
                          backgroundColor: "white",
                          fontWeight: "bold",
                          textDecoration: "none",
                          padding: "10px",
                        }}
                      >
                        HBR Account setup
                      </Link>
                    </div>
                  )
                }
              />

              <Route path="OnlineRadio" element={<OnlineRadio />} />
              <Route path="audioBooks" element={<AudioBooks />} />
              <Route path="chatRoom" element={<ChatRoom />} />
              <Route path="Register" element={<Register />} />
              <Route
                path="Login"
                element={<Login signInsuccess={handleSignInSuccess} />}
              />
              <Route path="UserDetails" element={<UserDetails />} />
              <Route path="AboutPage" element={<AboutPage />} />
              <Route path="devotionenglish" element={<DailyDevotion />} />
              <Route
                path="devotionenglish/:name/:id"
                element={<ReadDailyDevotion />}
              />
              <Route path="release" element={<ReleaseNote />} />
              <Route path="donation" element={<Donation />} />
              <Route path="assignment" element={<AssignmentPage />} />
              <Route path="assignment record" element={<AssignmentRecord />} />
              <Route path="view_all_records" element={<ViewAllRecords />} />
              <Route path="hrmwenglishbooks" element={<EnglishBksHome />} />
              <Route path="hbrbooks" element={<EnglishBksRead />} />
              <Route
                path="hrmwsavedbooks/:bookname/:id"
                element={<SavedBookReadPage />}
              />
              <Route path="hrmwfilipinobooks" element={<FilipinoBksHome />} />
              <Route
                path="hrmwfilipinobooks/:id"
                element={<FilipinoBksRead />}
              />
              <Route path="hrmwfrenchbooks" element={<FrenchBksHome />} />
              <Route path="hrmwfrenchbooks/:id" element={<FrenchBksRead />} />
              <Route path="hrmwgermanbooks" element={<GermanBksHome />} />
              <Route path="hrmwgermanbooks/:id" element={<GermanBksRead />} />
              <Route path="hrmwhindibooks" element={<HindiBksHome />} />
              <Route path="hrmwhindibooks/:id" element={<HindiBksRead />} />
              <Route path="hrmwspanishbooks" element={<SpanishBksHome />} />
              <Route path="hrmwspanishbooks/:id" element={<SpanishBksRead />} />
              <Route
                path="horemow_audio_messages"
                element={<AudioMessages />}
              />
              <Route
                path="hrmwaudiomessage/:name/:id"
                element={<PlayAudioMessage />}
              />
              <Route
                path="hrmwaudiobook/:name/:id"
                element={<PlayAudioBook />}
              />
              <Route path="horemow_video_messages" element={<VideoList />} />
              <Route
                path="horemow_video_hbr/:title/:id"
                element={<VideoPlayer />}
              />
              <Route
                path="hrmw_video_hbr/:title/:id"
                element={<VideoPlayerdual />}
              />
              <Route path="contact" element={<Feedback />} />
              <Route path="divineblogs" element={<DivineBlogs />} />
              <Route path="divineblog/:id" element={<BlogPost />} />
              <Route
                path="divineblogsvideo/:id"
                element={<BlogVideoPlayer />}
              />
              <Route path="account/update" element={<UpdateProfile />} />
              <Route path="account/delete" element={<Deleteaccount />} />
              <Route path="account/create" element={<UserAccout />} />
              <Route path="profilepage" element={<BloggerPage />} />
              <Route path="hbrbiblequiz" element={<Biblequizpage />} />
              {/* <Route path = "divineshorts/:id" element = {<Dshort/>}/> */}
              <Route path="creatordsb" element={<CreateUserandToken />} />
              <Route path="hbrlive" element={<ViewLiveStream />} />
              <Route path="hbrlivev2" element={<ViewAsHls />} />
              <Route path="hbrlivewebview" element={<CustomLiveWebview />} />
              <Route path="hbrpostlivevideos" element={<PostLiveVideos />} />
              <Route
                path="producer-dashboard"
                element={<ProducerDashboard />}
              />
              <Route path="holinesstv" element={<TvPage />} />
              <Route path="divineshorts/:id" element={<ShortVideoPlayer />} />
              <Route
                path="child-safety-policy"
                element={<ChildSafetyPolicy />}
              />
              <Route path="*" element={<Notfoundpage />} />
            </Route>
          </Routes>
        </div>

        {!LoginPage.show && (
          <div
            className={`vertical-menu ${open ? "show" : "hide"}`}
            ref={sideBarRef}
          >
            <nav className="verticalmenuoptions">
              <button
                onClick={() =>
                  navigate("/aboutPage", { state: { from: location.pathname } })
                }
              >
                About
              </button>

              <button
                onClick={() =>
                  navigate("/account/update", {
                    state: { from: location.pathname },
                  })
                }
              >
                Account settings
              </button>

              <button
                onClick={() =>
                  navigate(
                    `/profilepage?hbruserref=${sanitizeText(
                      user_email
                    )}&socialhandle=${userName}`,
                    { state: { from: location.pathname } }
                  )
                }
              >
                View profile
              </button>

              <button
                onClick={() =>
                  navigate("/account/delete", {
                    state: { from: location.pathname },
                  })
                }
              >
                Delete Account
              </button>

              <button
                onClick={() =>
                  navigate("/release?type=web", {
                    state: { from: location.pathname },
                  })
                }
              >
                Release Note
              </button>
              <button
                onClick={() =>
                  navigate("/contact", { state: { from: location.pathname } })
                }
              >
                Need Help?
              </button>
              <button
                onClick={() =>
                  navigate("/donation", { state: { from: location.pathname } })
                }
              >
                Support Us
              </button>

              <svg
                onClick={() => setOpen(false)}
                viewBox="0 0 24 24"
                fill="black"
                height="2em"
                width="2em"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" />
              </svg>
            </nav>
          </div>
        )}

        <div
          className={`viewreviewsheet flex-column1 ${
            state.showReviewSheet ? "show" : "hide"
          }`}
        >
          <div className="reviewtoptitle flex-spacebetween">
            <span style={{ fontWeight: "bold" }}>Reviews</span>
            <HbrCancel
              width={"1.8em"}
              height={"1.8em"}
              fillColour={"#000000"}
              handleClick={() =>
                dispatch({
                  type: actionConsts.SHOW_REVIEW_SHEET,
                  payload: false,
                })
              }
            />
          </div>

          <div className="viewreviewsheetcontent flex-column1">
            {state.bookReviewData && (
              <ReviewContent
                userName={state.bookReviewData.name}
                email={state.bookReviewData.email}
                message={state.bookReviewData.message}
                book_title={state.bookReviewData.book_title}
                country={state.bookReviewData.country}
                rate={state.bookReviewData.rate}
                timestamp={state.bookReviewData.timestamp}
                reviewID={state.bookReviewData.reviewID}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="App">
      <div
        className="splash-screen flex-column2"
        style={{ width: "100vw", height: "100vh" }}
      >
        <img src={appIcon} alt="" />
        <h3>Horemow Book Reader</h3>
        <h4>©HbrSoftTeam | 2025</h4>
      </div>
    </div>
  );
}
export default App;
